import React from 'react';
import { Datagrid, EditButton, List, TextField } from 'react-admin';

const LegalEntitiesList = (props) => (
  <List title="Legal Entities" bulkActionButtons={false} sort={{ field: 'id', order: 'DESC' }} {...props}>
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" sortable={false} />
      <TextField label="Type" source="type" sortable={false} />
      <TextField label="Name" source="name" sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export default LegalEntitiesList;
